/**
 * @file smqPrivileges.js
 * @description This file contains the constants for SMQ privileges.
 */
export const SMQ_PRIVILEGES = Object.freeze({
  READ: "nc_smq_user", // Droit de lecture
  CREATE: "nc_smq_create", // Droit de création
  TREAT: "nc_smq_treat", // Droit de traitement
  VALIDATE: "nc_smq_validate", // Droit de validation
  ADMIN: "nc_smq_admin", // Droit d'administration
  PROCESS_SCOPE: "nc_smq_scope_process", // Portée du processus
});
